import { render, staticRenderFns } from "./CEditFrame.vue?vue&type=template&id=729ca600&"
import script from "./CEditFrame.vue?vue&type=script&lang=ts&"
export * from "./CEditFrame.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports